module.exports = __webpack_public_path__ + "img/art6-img4.953f90d1.jpeg";